import Cookies from "js-cookie";
import store from "@/store";
import utils from "./utils";
import platInfo from "./platKey";
const Base64 = require("js-base64").Base64;
const plat_key = process.env.VUE_APP_KEY;
const platKey = platInfo.platKey;
let headers = {};
const auth = {
  isLogin() {
    return this.getToken() != "";
  },

  tokenKey: platKey + "_token",

  refreshTokenKey: platKey + "_refresh_token",
  /******************* localStorage *****************/
  //localStorage获取
  getLocalStorage(key) {
    let data = localStorage.getItem(key)
      ? JSON.parse(localStorage.getItem(key))
      : "";
    return data;
  },
  //localStorage存储
  setLocalStorage(key, value, expiryMin) {
    let max = 1 * 60 * 24 * 365;
    let newValue = value && value != undefined ? JSON.stringify(value) : "";
    if (!expiryMin || isNaN(expiryMin) || expiryMin > max) {
      /* 过期时间最大不超过 1 年 */
      expiryMin = max;
    }
    return localStorage.setItem(key, newValue);
  },
  //localStorage移除
  removeLocalStorage(key) {
    return localStorage[key] ? localStorage.removeItem(key) : "";
  },
  /******************* localStorage  end*****************/

  /******************* cookies  start*****************/
  //cookie获取
  getCookies(key) {
    let data = Cookies.get(key);
    return data ? data : "";
  },
  //cookie存储
  setCookies(key, value, expires) {
    return Cookies.set(key, value, { expires: expires || "" });
  },
  //cookie移除
  removeCookies(key) {
    return Cookies.remove(key); // removed!
  },
  //获取租户编码应用编码
  getTenantAppCode(type = "tenant") {
    let pathname = window.location.pathname;
    var index = pathname.lastIndexOf("/");
    let str = pathname.substring(index + 1, pathname.length);
    let matchArr = str ? str.split("&") : [];
    let tenantCode = matchArr.length
      ? Base64.decode(matchArr[0].substring(1))
      : ""; //T000001
    let appCode = process.env.VUE_APP_CODE; //AP000002
    if (type == "tenant") {
      return tenantCode;
    } else if (type == "app") {
      return appCode;
    } else if (type == "all") {
      return {
        "tenant-code": tenantCode,
        "app-code": appCode,
      };
    }
  },
    /**链接中租户编码转码 */
    tenantCodeEncode(tenantCode) {
      let encodeTenantCode = "T" + Base64.encode(tenantCode);
      return encodeTenantCode;
    },
  /**链接中移除租户编码或应用编码
   *@params type all(表示清空链接中租户编码和应用编码)；app(清空链接中的应用编码)
   */
  clearUrlCode(type = "all", noChange, isGoLogin) {
    // let localPath = platInfo.platPath
    //   ? platInfo.platPath
    //   : window.location.pathname;
    let localPath = JSON.parse(JSON.stringify(window.location.pathname));
    let pathname = localPath;
    var index = pathname.lastIndexOf("/");
    let str = pathname.substring(index + 1, pathname.length);
    let matchArr = str ? str.split("&") : [];
    let tenantCode = matchArr.length ? matchArr[0] : ""; //T000001
    let appCode = matchArr.length > 1 ? matchArr[1] : ""; //AP000002
    if (matchArr.length > 0) {
      if (type == "all") {
        pathname = pathname.replace(tenantCode, "");
        pathname = pathname.replace(appCode, "");
        pathname = pathname.replace("&", "");
      } else if (type == "app") {
        pathname = pathname.replace(appCode, "");
        pathname = pathname.replace("&", "");
      }
      if (noChange) {
        window.location.pathname = pathname;
      } else {
        window.location.pathname = platInfo.platPath
          ? platInfo.platPath
          : pathname;
      }
    }
  },
  /******************* cookies  end*****************/
  /**
   * 请求头配置
   */
  configHeader(otherHeader = {}, isRequest = false) {
    headers = {
      ...headers,
      ...{
        "login-plat": process.env.VUE_APP_LOGIN_PLAT,
        "tenant-code": this.getTenantAppCode(),
        "app-code": this.getTenantAppCode("app"),
      },
    };
    if (!isRequest) {
      let defaultKey = ["login-plat", "tenant-code", "app-code"];
      for (let key in otherHeader) {
        if (!defaultKey.includes(key)) {
          headers[key] = otherHeader[key];
        }
      }
      //身份信息
      if (this.getAppStorage("identity_info")) {
        let identityInfo = this.getAppStorage("identity_info");
        headers["user-identity"] = identityInfo.uuid || "";
      }
    }
    return headers;
  },
  /**系统注销-只关闭当前窗口，不跳转登录 */
  loginOut() {
    this.removeAllSession();
    store.commit("SET_USER_FLAG", false);
    store.commit("SET_MENU_FLAG", false);
    if (platInfo.platPath) {
      utils.windowClose();
    }
  },
  /**退出登录-清空token，跳转登录页面 */
  goLogin(toLogin = false) {
    // this.clearUrlCode();
    this.removeAllSession();
    let pathname = !platInfo.platPath
      ? "/" + process.env.VUE_APP_CODE + "/"
      : process.env.VUE_APP_PUBLIC_PATH + "/";
    let href = window.location.origin + pathname + "#/login";
    if (window.location.href != href) {
      window.location.href = href;
    }

    store.commit("SET_USER_FLAG", false);
    store.commit("SET_MENU_FLAG", false);
  },
  goPath(path) {
    // let pathname = window.location.pathname;
    let pathname = platInfo.platPath
      ? platInfo.platPath
      : window.location.pathname;
    let href = window.location.origin + pathname + "#" + path;
    window.location.href = href;
  },
  validPrivCode(code) {
    if (!code) {
      return true;
    }
    let menuPerssions = this.getStore("menuPerssions");
    let btnPermissions = this.getStore("btnPermissions");
    let data = [...menuPerssions, ...btnPermissions];
    if (data) {
      return data.includes(code);
    } else {
      return false;
    }
  },
  /**----------Token Begin----------*/
  getToken() {
    let data = this.getTokenData();
    return data ? data : "";
  },
  getTokenData() {
    return this.getLocalStorage(this.tokenKey);
  },
  saveToken(data) {
    return this.setLocalStorage(this.tokenKey, data);
  },
  removeToken() {
    return this.removeLocalStorage(this.tokenKey);
  },
  /**----------Token End----------*/
  /**----------储存应用缓存----------*/
  getAppStorage(dataKey) {
    let key = `${this.getTenantAppCode()}_${this.appCode}_${dataKey}`;
    return this.getLocalStorage(key);
  },
  saveAppStorage(dataKey, data) {
    let key = `${this.getTenantAppCode()}_${this.appCode}_${dataKey}`;
    return this.setLocalStorage(key, data);
  },
  removeAppStorage(dataKey) {
    let key = `${this.getTenantAppCode()}_${this.appCode}_${dataKey}`;
    return this.removeLocalStorage(key);
  },
  /**----------储存应用缓存----------*/
  /**登录其他信息储存,如refresh_token,过期时长,登录时间点 Start*/
  /**
   * 获取登录其他信息
   * @param {*} param 对象中参数名
   * @returns
   */
  getLoginInfo(param) {
    let data = "";
    data = JSON.parse(this.getLocalStorage(platKey + "_login"));
    if (!data) {
      return "";
    } else {
      if (param) {
        return data[param] || "";
      } else {
        return data;
      }
    }
  },
  saveLoginInfo(data) {
    return this.setLocalStorage(platKey + "_login", JSON.stringify(data));
  },
  removeLoginInfo() {
    return this.removeLocalStorage(platKey + "_login");
  },
  /**----------用户信息 Start----------*/
  getUserInfo() {
    let userData = "";
    if (this.getStore("userInfo")) {
      userData = this.getStore("userInfo");
    } else {
      userData = this.getLocalStorage(platKey + "_user");
    }
    return userData;
  },
  setUserInfo(data) {
    return this.setLocalStorage(platKey + "_user", data);
  },
  removeUserInfo() {
    return this.removeLocalStorage(platKey + "_user");
  },
  /**----------用户信息 End----------*/

  /**----------存取各系统缓存 Start---------- */

  getPlatLocalStorage(key) {
    let keyName =
      platKey + "_" + this.getTenantAppCode() + "_" + process.env.VUE_APP_CODE;
    return this.getLocalStorage(keyName + key);
  },
  setPlatLocalStorage(key, data) {
    let keyName =
      platKey + "_" + this.getTenantAppCode() + "_" + process.env.VUE_APP_CODE;
    return this.setLocalStorage(keyName + key, data);
  },
  removePlatLocalStorage(key) {
    let keyName =
      platKey + "_" + this.getTenantAppCode() + "_" + process.env.VUE_APP_CODE;
    return this.removeLocalStorage(keyName + key);
  },
  /**----------各系统缓存 End---------- */

  /**----------获取vuex缓存 Start---------- */
  getStore(param) {
    if (store.getters) {
      return store.getters[param];
    } else {
      return null;
    }
  },
  /**----------获取vuex缓存 End---------- */
  /**清楚所有缓存 */
  removeAllSession() {
    this.removeUserInfo();
    this.removeLoginInfo();
    if (this.getTokenData()) {
      this.removeToken();
    }
    for (let key in localStorage) {
      let new_key = key.replace(plat_key + "_", "");
      if (
        key.indexOf(plat_key + "_") != -1 &&
        !["account", "rememberAccount"].includes(new_key)
      ) {
        localStorage.removeItem(key);
      }
    }
  },
  removeAllCookie() {
    this.removeToken();
    var aCookie = document.cookie.split(";");
    for (var i = 0; i < aCookie.length; i++) {
      var aCrumb = aCookie[i].split("=");
      var key = aCrumb[0].toString();
      if (key) {
        this.delCookie(key);
      }
    }
  },
  delCookie(name) {
    let max = 1 * 60 * 24 * 365;
    document.cookie = name + "=" + "" + ";expires=" + max + ';path=""';
  },
};

export default auth;
